import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import SelectSearch from "react-select-search";
import { useQuery } from "@apollo/client";
import "react-select-search/style.css";
import "./Picker.css";
import { without } from "ramda";
import { GET_POLLS } from "../../routes/polls/graphql";

interface IPollPickerProps {
  handleChange: (pollId: string, option: string) => void;
  defaultValue?: string | null | undefined;
  value: string | undefined | null;
  placeholder?: string;
  controlStyle?: React.CSSProperties;
  except?: string[];
}

export const PollPicker = ({
  handleChange,
  defaultValue,
  value,
  placeholder,
  controlStyle,
  except,
}: IPollPickerProps) => {
  const { data, error, loading } = useQuery(GET_POLLS);

  const filtered = without([value], except ?? []);

  const options =
    data?.polls
      .filter((poll) => !filtered?.includes(poll.id))
      .map((poll) => ({
        name: poll.title,
        value: poll.id,
      })) ?? [];

  return (
    <FormControl
      fullWidth
      style={{
        marginTop: "20px",
        marginBottom: "20px",
        backgroundColor: "white",
        width: "100%",
        ...controlStyle,
      }}
    >
      <InputLabel id="poll-picker-select-label">Poll name</InputLabel>
      <SelectSearch
        options={options}
        value={value ?? ""}
        search={true}
        placeholder={placeholder ?? "Select a poll"}
        onChange={(val, option) =>
          handleChange(val as string, option as unknown as string)
        }
      />
    </FormControl>
  );
};
